
export default {
  functional: true,
  abstart: true,
  props: {
    renderFun: {
      type: Function,
      required: true
    }
  },
  render (h, context) {
    return context.props.renderFun(h)
  }
}
